import { render, staticRenderFns } from "./AuditCriteriaFile.vue?vue&type=template&id=54ddf833&"
import script from "./AuditCriteriaFile.vue?vue&type=script&lang=js&"
export * from "./AuditCriteriaFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports